











import { Vue, Component, Prop } from 'vue-property-decorator';
import { BottomTabbar, Banner } from '@/components';
import * as config from './config';
import { getBaseinfo } from './api/index';
import { appShare, wxShareInfo } from '@/common/ts/common';

@Component({
  components: {
    BottomTabbar,
    Banner,
  },
})
export default class Home extends Vue {
  bannerSrc = require('./assets/banner.jpg');
  baseInfo: any = {};
  options = config.OPTHINES;
  // created() {
  //   // 新版分享方案
  //   appShare({
  //     title: `重庆药房100强品牌推介活动`,
  //     url: location.href,
  //     subtitle: '重庆药房100强品牌推介活动',
  //     classId: -1,
  //     id: -1,
  //     type: 3,
  //   });
  //   wxShareInfo({
  //     title: '重庆药房100强品牌推介活动',
  //     subtitle: '重庆药房100强品牌推介活动',
  //   });
  // }
  created() {
    console.log('home created');
    getBaseinfo().then((res: any) => {
      this.baseInfo = res.data;
      this.$addPv(this.baseInfo.activityId);
    });

    // 分享
    this.$appShareInfo({
      title: '重庆药房100强品牌推介活动',
      url: window.location.href,
      subtitle: '重庆药房100强品牌推介活动',
      classId: -1,
      id: -1,
      image: 'http://image2.cqcb.com/1075dd015b5d3b3545e6379f33081b4e.jpeg',
      type: 3,
    });
    this.$wxShareInfo({
      title: '重庆药房100强品牌推介活动',
      subtitle: '重庆药房100强品牌推介活动',
      image: 'http://image2.cqcb.com/1075dd015b5d3b3545e6379f33081b4e.jpeg',
    });
  }
}
